<template>
  <div class="goods_index">
    <div class="shop_top">
      <shop-top
        :subnav_show="false"
        :change_color="true"
        :keyword="goodsParams.name"
        @search="handleSearch"
      ></shop-top>
    </div>

    <div v-loading="loading" class="goods_where width_center_1200">
      <div class="head">{{ lang.all_goods }}</div>
      <div class="classify">
        <div class="item">
          <div class="title">{{ lang.classify }}：</div>
          <ul>
            <li
              v-for="(item, index) in classify"
              :key="index"
              :class="{ 'cur': item === goodsParams.type }"
              @click="handleClassify(1, item, index)"
            >{{ item }}</li>
          </ul>
        </div>
        <div class="item">
          <div class="title">{{ lang.brand }}：</div>
          <ul>
            <li
              v-for="(item, index) in brand"
              :key="index"
              :class="{ 'cur': item === goodsParams.brand }"
              @click="handleClassify(2, item, index)"
            >{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="width_center_1200">
      <div class="goods_list" v-if="goodsList.length > 0">
        <ul>
          <li v-for="item in goodsList" :key="item.id">
            <goods :item="item"></goods>
          </li>
        </ul>
        <div class="clear"></div>
      </div>
      <el-empty v-else :description="lang.no_data"></el-empty>
    </div>

    <div class="home_fy_block width_center_1200">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next,jumper,total"
        :total="total"
        :page-size="goodsParams.pageSize"
        :current-page="goodsParams.pageNum"
      ></el-pagination>
    </div>

    <merchant-promise></merchant-promise>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import ShopTop from '@/components/ShopHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
import MerchantPromise from '@/components/MerchantPromise/index'
import goods from '@/components/ShopGoods/index'
import {
  getproducttype,
  getproductbrand,
  getproductlist
} from '@/api/product.js'
export default {
  components: {
    ShopTop,
    ShopFoot,
    MerchantPromise,
    goods
  },
  data() {
    return {
      classify: [],
      brand: [],
      goodsList: [],
      total: 0,
      goodsParams: {
        name: '',
        type: '',
        brand: '',
        ptype: 0,
        ishot: 0,
        pageNum: 1,
        pageSize: 20
      },
      loading: false
    }
  },
  computed: {
    lang() {
      return this.$t('goods')
    }
  },
  async created() {
    const keyword = this.$route.query.keyword
    const typeName = this.$route.query.name
    if (keyword) {
      this.goodsParams.name = keyword
    }
    if (typeName) {
      this.goodsParams.type = typeName
    }
    this.loading = true
    this.getClassify()
  },
  methods: {
    getClassify() {
      getproducttype().then(({ data }) => {
        this.classify = data
        this.goodsParams.type = data[0]
        getproductbrand().then(({ data }) => {
          this.goodsParams.brand = data[0]
          this.brand = data
          this.getList()
        })
      })
    },
    getList() {
      getproductlist(this.goodsParams).then(({ data }) => {
        this.total = data.count
        this.loading = false
        this.goodsList = data.data.map((item) => {
          return {
            ...item,
            title: item.mercName,
            thumbnailsImage: item.thumbnailsImage,
            canSaleCount: item.canSaleCount,
            productno: item.productno
          }
        })
      })
    },
    handleClassify(type, value, index) {
      if (index === 0) {
        this.goodsParams.name = ''
      }
      if (type === 1) {
        this.goodsParams.type = value
      } else {
        this.goodsParams.brand = value
      }
      this.goodsParams.pageNum = 1
      this.getList()
    },
    changePage(val) {
      this.goodsParams.pageNum = val
      this.getList()
    },
    handleSearch(name) {
      this.goodsParams.name = name
      this.getList()
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.goodsParams.type = to.query.name
    this.goodsParams.pageNum = 1
    this.goodsList = []
    this.getList()
    next()
  }
}
</script>

<style lang="scss" scoped>
.goods_where {
  margin: 10px auto 20px;
  .head {
    position: relative;
    text-align: center;
    width: 94px;
    height: 30px;
    line-height: 30px;
    background: #ec9221;
    color: #fff;
    font-size: 14px;
    margin-bottom: 15px;
    &::after {
      content: ' ';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 1200px;
      height: 1px;
      background: #ec9221;
    }
  }
  .classify {
    background: #fff;
    padding: 0 15px;
    .item {
      display: flex;
      flex-wrap: wrap;
      line-height: 48px;
      &:first-child {
        border-bottom: 1px solid #f0f0f0;
      }
      .title {
        min-width: 72px;
        font-size: 14px;
        color: #4f4f4f;
      }
      ul {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        li {
          font-size: 14px;
          color: #000;
          margin-right: 30px;
          &:hover,
          &.cur {
            cursor: pointer;
            color: #ec9221;
          }
        }
      }
    }
  }
}

.goods_list {
  padding-bottom: 20px;
  width: 110%;
  li {
    float: left;
    box-sizing: border-box;
    margin-right: 16px;
    margin-bottom: 16px;
    width: 288px;
    height: 110px;
  }
}
</style>